const groupByProp = (objectToGroup, key) => objectToGroup.reduce((groupedObject, objectItem) => {
  const keyItem = objectItem[key];
  if (!(`${keyItem}` in groupedObject)) {
    Object.assign(groupedObject, { [keyItem]: [] });
  }
  groupedObject[keyItem].push(objectItem);
  return groupedObject;
}, /* @__PURE__ */ Object.create(null));
const groupByMapProp = (objectToGroup, key) => objectToGroup.reduce((groupedObject, objectItem) => {
  const keyItem = objectItem[key];
  if (!groupedObject.has(keyItem)) {
    groupedObject.set(keyItem, []);
  }
  groupedObject.get(keyItem).push(objectItem);
  return groupedObject;
}, /* @__PURE__ */ new Map());
const generateKey = (keys, objectItem) => keys.map((key) => objectItem[key]).filter((key) => !!key).join("_");
const groupByMultiplyProp = (objectToGroup, keys) => objectToGroup.reduce((groupedObject, objectItem) => {
  const keyItem = generateKey(keys, objectItem);
  Object.assign(groupedObject, { [keyItem]: objectItem });
  return groupedObject;
}, /* @__PURE__ */ Object.create(null));
const groupByMultiplyMapProp = (objectToGroup, keys) => objectToGroup.reduce((groupedObject, objectItem) => {
  const keyItem = generateKey(keys, objectItem);
  groupedObject.set(keyItem, objectItem);
  return groupedObject;
}, /* @__PURE__ */ new Map());
const groupArrayToKeyData = (arrayToGroup, key) => arrayToGroup.reduce((groupedObject, objectItem) => {
  const keyItem = objectItem[key];
  Object.assign(groupedObject, { [keyItem]: objectItem });
  return groupedObject;
}, /* @__PURE__ */ Object.create(null));
const groupByKeyValue = (objectToGroup, key, valueKey) => objectToGroup.reduce((groupedObject, objectItem) => {
  const keyItem = objectItem[key];
  groupedObject[keyItem] = objectItem[valueKey] || null;
  return groupedObject;
}, {});
export {
  generateKey,
  groupArrayToKeyData,
  groupByKeyValue,
  groupByMapProp,
  groupByMultiplyMapProp,
  groupByMultiplyProp,
  groupByProp
};
